import { css } from 'styled-components';
import { newColors, metrics } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
const styles = css `
  background-color: ${newColors.snow};
  width: 100%;
  max-width: ${metrics.maxWidth}px;
  box-sizing: border-box;
  position: relative;
  top: 0px;
  height: 120px;
  padding: 0px 48px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${mediaq.md `
    padding: 0px 36px;
  `}
  ${mediaq.sm `
    height: 60px;
    padding: 0px 12px;
  `}
  .header-button {
    display: inline-block;
    padding-left: 20px;
    ${mediaq.md `
      padding-left: 8px;
    `}
    ${mediaq.sm `
      display: none;
    `}
  }
  .mobile-menu {
    display: none;
    text-align: right;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    ${mediaq.sm `
      display: block;
      background: ${newColors.purple100};
    `}
  }

  .tech-support-container {
    display: none;
    position: absolute;
    top: 90px;
    right: 10px;
    box-shadow: 0px 4px 20px 0px ${newColors.darkBlueAlpha12};
    border-radius: 18px;
    flex-direction: column;
    align-items: flex-start;
    z-index: 9;
    &.tech-support-visible {
      display: block;
    }
    .tech-support-inner-container {
      background-color: ${newColors.snow};
      border-radius: 16px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      .tech-support-block {
        border-bottom: 1px solid ${newColors.gray100};
        padding: 16px;
      }
      .obituary-link {
        padding: 16px;
        display: none;
        ${mediaq.sm `
          display: block;
          border-bottom: 1px solid ${newColors.gray100};
        `}
        .obituary-icon-container {
          display: flex;
          width: 38px;
          svg {
            display: block;
            margin: auto;
          }
        }
      }
      .tech-support-row {
        display: flex;
        flex-direction: row;
        width: 100%;
        .tech-support-icon-container {
          display: flex;
          width: 38px;
          height: 38px;
          border-radius: 50px;
          background-color: ${newColors.gray};
          svg {
            display: block;
            margin: auto;
          }
        }
        .tech-support-message {
          flex: 3;
          color: ${newColors.gray800};
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
        }
      }
      .tech-support-link {
        text-decoration: none;
        &:hover {
          text-decoration: none;
        }
      }
      .tech-support-button {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        padding: 10px 16px;
        background: ${newColors.purple500};
        border-radius: 30px;
        font-family: 'Inter Variable', sans-serif;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: ${newColors.snow};
        border: none;
      }
      .tech-support-footer {
        padding: 16px;
        .tech-support-phrase {
          font-family: 'Inter Variable', sans-serif;
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          color: ${newColors.gray800};
          margin: 0;
          padding: 0;
          a {
            color: ${newColors.purple500};
            text-decoration: underline;
          }
        }
      }
    }
  }
`;
export default styles;
